module.exports = __webpack_public_path__ + "img/step3.b8d1632d.png";